/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_CarrierInputs */

const en_carrier_notices_carrier = /** @type {(inputs: Carrier_Notices_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier`)
};

const es_carrier_notices_carrier = /** @type {(inputs: Carrier_Notices_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista`)
};

/**
* | output |
* | --- |
* | "Carrier" |
*
* @param {Carrier_Notices_CarrierInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_carrier = /** @type {((inputs?: Carrier_Notices_CarrierInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_CarrierInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_carrier(inputs)
	return es_carrier_notices_carrier(inputs)
});